import FetchData from "./FetchData";

function App() {
  return (
    <div className="App">
      <FetchData />
    </div>
  );
}

export default App;
